export default {
  SOCIETY_VALUATION_OUTDATED: 'notification-society-valuation-outdated',
  MEMBER_HAS_TENDER_OFFER: 'notification-member-has-tender-offer',
  PARTNER_IS_ABSENT: 'notification-partner-is-absent',
  OPEN_VOTING: 'notification-open-voting',
  NOT_DELIVERED_ANNOUNCEMENT: 'notification-not-delivered-announcement',
};
